import { AccountNotFoundError, } from "@alchemy/aa-core";
import {} from "viem";
import { MultiOwnerPlugin, multiOwnerPluginActions as multiOwnerPluginActions_, } from "./plugin.js";
export const multiOwnerPluginActions = (client) => ({
    ...multiOwnerPluginActions_(client),
    async readOwners(args) {
        const account = args?.account ?? client.account;
        if (!account) {
            throw new AccountNotFoundError();
        }
        const contract = MultiOwnerPlugin.getContract(client, args?.pluginAddress);
        return contract.read.ownersOf([account.address]);
    },
    async isOwnerOf(args) {
        const account = args.account ?? client.account;
        if (!account) {
            throw new AccountNotFoundError();
        }
        const contract = MultiOwnerPlugin.getContract(client, args.pluginAddress);
        return contract.read.isOwnerOf([account.address, args.address]);
    },
});
//# sourceMappingURL=extension.js.map